import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ManageCardsServiceService } from '../../credit-card-management/manage-cards-service.service';
import { PayService } from '../../invoices/pay.service';

@Component({
  selector: 'app-credit-card-payment-cvv-dialog',
  templateUrl: './credit-card-payment-cvv-dialog.component.html',
  styleUrls: ['./credit-card-payment-cvv-dialog.component.scss'],
})
export class CreditCardPaymentCVVDialogComponent implements OnInit {
  @Input() selectedPayOption;
  loading = false;
  cardCVV2 = '';

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() { }

  doPayment() {
    this.loading = true;
    this.selectedPayOption.cardCVV2 = this.cardCVV2;
    this.activeModal.close(true);
  }

}
